// extracted by mini-css-extract-plugin
export default {"cont_promise":"BrandPromise_cont_promise__bCCiW","heading_prom":"BrandPromise_heading_prom__rBLt5","desc":"BrandPromise_desc__YXk3N","para_prom":"BrandPromise_para_prom__M1-d1"};